<template>
  <Banner class="Hosting">
    <!-- <Overlay slot="overlay"></Overlay> -->

    <template slot="header">
      <h1>Hosting Statistics</h1>
    </template>

    <template slot="caption">
      This list shows the most actively hosted games on Warcraft III. It is updated every 60 seconds. Records are grouped by the regular map name without any versioning. For example, Broken Alliances 6.2f and Broken Alliances 7.3g are both counted towards hosting stats for Broken Alliances.

      <div class="d-flex flex-row mt-5 mb-0">
        <input
          type="text"
          placeholder="Map Search (e.x. Broken Alliances)"
          v-model="search"
          class="w50"
          autofocus
        >

        <input
          type="text"
          placeholder="Slots (e.x. 12, 1-6)"
          v-model="slots"
          class="w25 ml-4"
        >

        <input
          type="number"
          min="1"
          max="200"
          placeholder="Limit"
          v-model="limit"
          class="w15 ml-4"
        >

        <select
          v-model="lookback"
          class="w10 ml-4"
          style="padding: 0; margin: 0; font-size: 18px;"
        >
          <option value="1D">1D</option>
          <option value="2D">2D</option>
          <option value="3D">3D</option>
          <option value="4D">4D</option>
          <option value="5D">5D</option>
          <option value="6D">6D</option>
          <option value="1W">1W</option>
          <option value="2W">2W</option>
          <option value="4W">4W</option>
        </select>
      </div>

      <div
        class="Hosting-input-error"
        v-if="error"
      >
        Error: {{ error }}
      </div>


    </template>

    <template slot="content">

      <Loader
        :url="endpoint"
        v-model="maps"
      >
        <div slot="result">
          <template v-if="maps.length > 0">
            <div v-for="r in k" class="row">
              <div v-for="c in cols" v-if="idx (r, c) < maps.length" class="col-lg-4" :key="c">
                <div class="Hosting-row--container overflow-hidden" @click="toggle (idx (r, c))">
                  <Panel
                    class="clickable"
                    :class="{
                      'toggled' : idx (r, c) === toggled
                    }"
                  >
                    <template slot="body">
                      <div class="Hosting-row">
                        <div class="Hosting-row--rank-container">
                          <span class="Hosting-row--rank">{{ maps [idx (r, c)].rank }}</span>
                        </div>

                        <div class="Hosting-row--header">
                          <h3 class="yellow text-truncate">{{ maps [idx (r, c)].map }}</h3>
                          <h5 class="text-truncate">Hosted {{ maps [idx (r, c)].hosted }} {{ pluralize (maps [idx (r, c)].hosted, 'time') }}</h5>
                        </div>

                        <div class="Hosting-row--angle ml-auto">
                          <div
                            class="small"
                            :class="{
                              'angle-up' : idx (r, c) == toggled,
                              'angle-down' : idx (r, c) != toggled
                            }"
                          ></div>
                        </div>
                      </div>

                      <div
                        class="Hosting-row--ribbon"
                        :style="`background: linear-gradient(to right, rgba(var(--wc3-${slotColour (maps [idx (r, c)].slots)}), .2), rgba(var(--wc3-${slotColour (maps [idx (r, c)].slots)}), .8))`"
                        v-if="maps [idx (r, c)].slots > 0"
                      >
                        <span
                          v-tooltip="`${maps [idx (r, c)].slots} Player Map`"
                        >
                          {{ maps [idx (r, c)].slots }}
                        </span>
                      </div>

                      <Bar :fill="maps [idx (r, c)].hosted / maps [0].hosted * 100"></Bar>
                    </template>
                  </Panel>
                </div>
              </div>

              <transition
                appear
                appear-active-class="fade-enter-active"
                v-if="rowIdxs (r).includes (toggled)"
              >
                <div class="col-lg-12">
                  <Panel class="Hosting-row--container">
                    <template slot="body">
                      <div class="row">
                        <div class="col-lg-4">
                          <div
                            v-for="cfg in [
                              { 'key' : 'versions', 'title' : 'Top Versions' },
                              { 'key' : 'hosts', 'title' : 'Top Hosts' }
                            ]"
                            class="mb-4"
                          >
                            <h4 class="text mb-3">{{ cfg.title }}</h4>
                            <ul class="list-unstyled">
                              <li
                                v-for="(item, index) in maps [toggled] [cfg.key]"
                                v-if="index < 20"
                                class="mb-3 pb-2 position-relative"
                              >
                                <div class="text-truncate yellow">{{ item.map || item.name }}</div>
                                <div class="text-small muted">Hosted {{ item.count }} {{ pluralize (item.count, 'time') }}</div>
                                <Bar
                                  :fill="item.count / maps [toggled] [cfg.key] [0].count * 100"
                                ></Bar>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div class="col-lg-8">
                          <h4 class="text-center">Trends</h4>
                          <LineChart :series="getActiveSeries ()"
                                     :key="idx (r, $parent.c)"
                                     :timescale="true"
                                     :autoScale="false"
                                     :height="400"
                                     :labels="{
                                        x: 'Date',
                                        y: 'Games',
                                        uX: '',
                                        uY: ''
                                      }"
                          ></LineChart>

                          <h4 class="text-center mt-4">Fill Stats</h4>
                          <BarChart
                            :series="{ value: {} }"
                            :data="getActiveBarSeries ()"
                          />

                          <h4 class="text-center mt-4">Lobby Duration</h4>
                          <div style="margin: 20px 30px 30px 60px;">
                            <Histogram
                              title="Uptime (minutes)"
                              :data="maps [toggled].uptime"
                              style="height: 480px;"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </Panel>
                </div>
              </transition>
            </div>
          </template>

          <div v-else class="W3S-error w-50">
            No maps found.
          </div>
        </div>
      </Loader>
    </template>
  </Banner>
</template>

<script>
  import * as moment from 'moment';
  import Bar from '@/legacy/components/widgets/Bar';
  import BarChart from '@/legacy/components/widgets/BarChart';
  import Banner from '@/legacy/components/layout/Banner';
  import Loader from '@/legacy/components/widgets/Loader';
  import Panel from '@/legacy/components/widgets/Panel';
  import LineChart from '@/legacy/components/widgets/LineChart';
  import Histogram from '@/legacy/components/widgets/Histogram';
  import { metaFactory, codeToColour, pluralize } from '@/legacy/lib//template';
  import { interpolateColour } from '@/legacy/lib//util';

  export default {
    metaInfo () {
      return metaFactory ({
        title: 'Hosting Statistics',
        description: 'A nearly real-time directory of Warcraft III custom game hosting statistics.'
      })
    },

    components: {
      Banner,
      Loader,
      Panel,
      LineChart,
      Bar,
      BarChart,
      Histogram
    },

    data () {
      return {
        cols: 3,
        search: '',
        slots: '',
        limit: '',
        lookback: '1W',
        maps: [],
        endpoint: '/reports/hosting',
        toggled: null,
        error: ''
      }
    },

    methods: {
      pluralize,
      codeToColour,
      interpolateColour,

      idx (r, c) {
        return (r + (c - 1) * this.k) - 1;
      },

      rowIdxs (r) {
        let l = [];

        for (let c = 1; c <= this.cols; c++) {
          l.push (this.idx (r, c));
        }

        return l;
      },

      slotColour (s) {
        if (s <= 6) {
          return 'purple';
        } else if (s <= 12) {
          return 'green';
        } else if (s <= 18) {
          return 'orange';
        } else {
          return 'red';
        }
      },

      toggle (i) {
        if (this.toggled === i) {
          this.toggled = null;
          return;
        }

        let map = this.maps [i];
        this.toggled = i;
      },

      getActiveSeries () {
        if (!this.maps.length) {
          return [];
        }

        let series = [];

        if (this.maps [this.toggled].timeline.length) {
          series.push ({
            label: 'Hosted',
            colour: codeToColour (0),
            points: this.maps [this.toggled].timeline.map (d => {
              if (!Number.isInteger (d.date)) {
                d.date = moment (d.date, 'YYYY-MM-DD').unix ();
              }

              return {
                x: d.date,
                y: d.hosted
              }
            })
          });

          series.push ({
            label: 'Started (Full)',
            colour: codeToColour (1),
            points: this.maps [this.toggled].timeline.map (d => {
              if (!Number.isInteger (d.date)) {
                d.date = moment (d.date, 'YYYY-MM-DD').unix ();
              }

              return {
                x: d.date,
                y: d.started
              }
            })
          });
        }

        // if (this.maps [this.toggled].history.uploads.length) {
        //   series.push ({
        //     label: 'Uploads',
        //     colour: codeToColour (1),
        //     points: this.maps [this.toggled].history.uploads.map (d => {
        //       if (!Number.isInteger (d.x)) {
        //         d.x = moment (d.x, 'YYYY-MM-DD').unix ();
        //       }

        //       return d;
        //     })
        //   });
        // }

        return series;
      },

      getActiveBarSeries () {
        if (!this.maps.length) {
          return [];
        }

        let series = {};

        for (let x of Object.keys (this.maps [this.toggled].fill).reverse ()) {
          series [`${x} Players`] = { value: this.maps [this.toggled].fill [x] };
        }

        return series;
      },

      refresh () {
        if (this.slots.length > 0) {
          let pts = this.slots.split ('-');

          if (
            pts.length > 2 ||
            (pts.length > 0  && (!/\d+/.test (pts [0]) || +(pts [0]) < 1 || +(pts [0]) > 24)) ||
            (pts.length == 2 && (!/\d+/.test (pts [1]) || +(pts [1]) < 1 || +(pts [1]) > 24))
          ) {
            this.error = 'Slots must be either a number between 1 and 24 or a range between 1 and 24 (e.x. 3-8)';
          } else {
            this.error = '';
          }
        } else {
          this.error = '';
        }

        if (this.interval) {
          clearTimeout (this.interval);
        }

        this.interval = setTimeout (() => {
          if (this.error.length <= 0) {
            this.endpoint = `/reports/hosting?map=${this.search}&slots=${this.slots}&limit=${this.limit}&interval=${this.lookback}`;
          }
        }, 1000);
      }
    },

    computed: {
      k () {
        return Math.ceil (this.maps.length / 3);
      }
    },

    watch: {
      search () {
        this.refresh ();
      },

      slots () {
        this.refresh ();
      },

      limit () {
        this.refresh ();
      },

      lookback () {
        this.refresh ();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .Hosting {
    // Other
    background-color: rgba(var(--black), 1);
    background: asset('background/orc-camp-repeatable.png')  no-repeat;
    background-size: 100% auto;

    &-row {
      display: flex;
      flex-direction: row;
      // padding: 1rem 0;
      // border-top: fetch(border faint);

      // &:last-child {
      //   border-bottom: fetch(border faint);
      // }

      &--container {
        margin-bottom: 1rem;
      }

      &--rank {
        &-container {
          width: 70px;
          height: 70px;
          background-image: url('/assets/sword-portrait.png');
          background-size: cover;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1rem;
        }

        margin-top: 1rem;
        font-size: 1.2rem;
        font-family: 'Folkard';
        color: rgba(var(--tan), 1);
      }

      &--header {
        max-width: 230px;

        h3 {
          font-size: 1.4rem;
        }

        h5 {
          font-size: 1.1rem;
        }
      }

      &--angle {
        margin-right: 2rem;
      }

      &--ribbon {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 24px;
        font-size: 1rem;
        padding-left: 2rem;

        width: 150px;
        background: rgba(var(--white), .1);
        position: absolute;
        text-align: center;
        letter-spacing: 1px;
        color: #f0f0f0;
        top: 0;
        right: -40px;

        left: auto;
        transform: rotate(45deg);
      }
    }

    &-input-error {
      color: rgba(var(--red), 1);
      font-size: 1rem;
      margin-top: .4rem;
    }
  }

  .Panel {
    position: relative;

    &.toggled {
      background-color: rgba(var(--white), .1);
    }
  }

  .Bar {
    left: 0;
    right: 0;
  }
</style>